<template>
  <div id="app">
      <filePhone></filePhone>
  
  </div>
</template>

<script>
import filePhone from './components/filePhone.vue'

export default {
  name: 'App',
  components: {
    filePhone
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}
</style>
